var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('layout',{attrs:{"title":"Partneri"}},[_c('a',{staticClass:"btn btn-green mx-4 float-right clean",attrs:{"href":"partners/create"}},[_vm._v("Vytvoriť partnera")]),_c('div',{staticClass:"clear"}),_c('table-component',{attrs:{"keys":_vm.keys,"api":_vm.apiCall,"links":_vm.links}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }